import { NavListItem, NavListSection } from "#root/components/nav-list";
import Sidebar from "#root/components/sidebar";
import { WithSidebar } from "#root/components/withSidebar";
import type { ReactNode } from "react";
import { MdOutlineEmail, MdReceipt, MdStorage } from "react-icons/md";
import { NavLink } from "react-router-dom";
import Layout from "../layout";

export type BillingLayoutProps = Parameters<typeof Layout>[0] & {
  invoiceElements?: ReactNode;
  correspondenceElements?: ReactNode;
  newsrpmElements?: ReactNode;
};

export default function ({ invoiceElements, correspondenceElements, newsrpmElements, children, ...props }: BillingLayoutProps): ReactNode {
  return (
    <Layout {...props}>
      <WithSidebar>
        <Sidebar>
          <NavLink to="/billing/invoice">
            <NavListItem icon={MdReceipt}>Invoices</NavListItem>
          </NavLink>
          {invoiceElements ? <NavListSection>{invoiceElements}</NavListSection> : null}
          <NavLink to="/billing/correspondence">
            <NavListItem icon={MdOutlineEmail}>Correspondence</NavListItem>
          </NavLink>
          {correspondenceElements ? <NavListSection>{correspondenceElements}</NavListSection> : null}
          <NavLink to="/billing/usage">
            <NavListItem icon={MdStorage}>API Usage</NavListItem>
          </NavLink>
        </Sidebar>
        {children}
      </WithSidebar>
    </Layout>
  );
}
